<template>
	<div class="add-sub container-fluid">

		<div class="row">
			<div class="block highlighted-content">
				<div>
					<fieldset class="digits-field squared">
						<div>
							<div class="form-check">
								<label class="form-check-label">
									<input type="radio" class="form-check-input" :value="[11, 19]" v-model="mode" />

									<p class="form-check-value">11-19</p>
								</label>
							</div>

							<div class="form-check">
								<label class="form-check-label">
									<input type="radio" class="form-check-input" :value="[20, 29]" v-model="mode" />

									<p class="form-check-value">20-29</p>
								</label>
							</div>

							<div class="form-check">
								<label class="form-check-label">
									<input type="radio" class="form-check-input" :value="[30, 70]" v-model="mode" />

									<p class="form-check-value">30-79</p>
								</label>
							</div>

							<div class="form-check">
								<label class="form-check-label">
									<input type="radio" class="form-check-input" :value="[80, 120]" v-model="mode" />

									<p class="form-check-value">80-120</p>
								</label>
							</div>
						</div>

					</fieldset>
					<!-- <button @click="startGame([11, 19])" class="btn btn-lg btn-secondary">
					11-19
				</button>
				<button @click="startGame([20, 29])" class="btn btn-lg btn-secondary">
					20-29
				</button>
				<button @click="startGame([30, 70])" class="btn btn-lg btn-secondary">
					30-70
				</button>
				<button @click="startGame([80, 120])" class="btn btn-lg btn-secondary">
					80-120
				</button> -->
				</div>

				<!-- <div @click="$router.go(-1)" class="text-uppercase btn btn-pink">
					{{ 'Back' | translate }}
				</div> -->


				<div>
					<button @click="startGame(mode)" class="text-uppercase btn btn-success">
						{{ 'Start' | translate }}
					</button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'squared-settings',
	data() {
		return {
			mode: [11, 19]
		}
	},
	computed: {
		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},
	},
	methods: {
		startGame(numbers) {
			let data = {
				type: 'multiply_quad',
				numbers,
				places: 1,
				length: 1,
				speed: 1.6,
				withSound: false,
			}
			this.$store.commit('changeGameConfig', data)
			this.$router.push({ path: '/games/game' })
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.digits-field.squared {
	width: 100%;
	padding: 20px 30px;

	& .form-check-value {
		width: 54px;
		text-align: center;
		margin: 0;
	}
}

.btn-secondary {
	width: 150px;
	display: block;
	margin: 15px auto;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	line-height: 2;
	margin: 10px 15px;
	cursor: pointer;
	width: 150px;
}

.btn-pink:hover {
	background-color: #e85183;
}

.block {
	display: flex;
	flex-direction: column;

	// text-align: center;
	width: fit-content;
	padding: 15px;
	margin: 15px auto 0;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		// border: 2px solid red;
		color: #212529;

		box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);
	}

	& h6 {
		margin: 0;
	}

	@media (max-width: 767px) {
		display: block;
		text-align: center;
	}
}
</style>
